// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_List from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as ClonedDiv$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/drag-and-drop/ClonedDiv.bs.js";
import * as CorePricingContext from "../../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as Draggable$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/drag-and-drop/Draggable.bs.js";
import * as Droppable$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/drag-and-drop/Droppable.bs.js";
import * as ReactBeautifulDnd from "react-beautiful-dnd";
import * as ModificationsContext from "../../../../library/modifications-context/ModificationsContext.bs.js";
import * as ModificationListItemView from "./ModificationListItemView.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../assets/PricingDashboardAssetsManager.bs.js";

var move_icon = PricingDashboardAssetsManager.getImage("move-icon.svg");

function reorderLst(old_lst, source_index, destination_index, update_priority) {
  var shuffled_ele = Belt_List.get(old_lst, source_index);
  if (shuffled_ele === undefined) {
    return ;
  }
  var split_lst = Belt_List.splitAt(Belt_List.keepWithIndex(old_lst, (function (param, index) {
              return source_index !== index;
            })), destination_index);
  if (split_lst !== undefined) {
    return Curry._1(update_priority, List.append(List.append(split_lst[0], {
                        hd: shuffled_ele,
                        tl: /* [] */0
                      }), split_lst[1]));
  }
  
}

function onDragEnd(old_priorities, result, update_priority) {
  var match = result.destination;
  if (match !== undefined) {
    return reorderLst(old_priorities, result.source.index, match.index, update_priority);
  }
  
}

function DragAndDropModification(Props) {
  var modifications = Props.modifications;
  var priority = Props.priority;
  var is_prioritised = Props.is_prioritised;
  var is_core_pricing_pending = Props.is_core_pricing_pending;
  var update_priority = Props.update_priority;
  var open_modal = Props.open_modal;
  var take_action_cb = Props.take_action_cb;
  var match = CorePricingContext.useContext(undefined);
  var role = match.role;
  var match$1 = ModificationsContext.useContext(undefined);
  var edited_modifications = match$1.edited_modifications;
  var priority_number = {
    contents: 0
  };
  return React.createElement(ReactBeautifulDnd.DragDropContext, {
              onDragEnd: (function (result, param) {
                  return onDragEnd(priority, result, update_priority);
                }),
              children: React.createElement(ReactBeautifulDnd.Droppable, {
                    droppableId: "droppable",
                    children: (function (provided, _snapshot) {
                        var e = provided.placeholder;
                        return React.createElement(ClonedDiv$Catalyst.make, {
                                    props: Droppable$Catalyst.droppableProvidedPropsToJs(provided.droppableProps, provided.innerRef),
                                    children: React.createElement(React.Fragment, undefined, ReasonReactUtils$Catalyst.listToReactArray(List.mapi((function (index, external_id) {
                                                    var modification = modifications[external_id];
                                                    var action_taken = Js_dict.get(edited_modifications, external_id);
                                                    var is_edited = Object.keys(edited_modifications).length !== 0;
                                                    var p = action_taken !== undefined && !(action_taken !== 1 && action_taken < 3) ? undefined : (priority_number.contents = priority_number.contents + 1 | 0, priority_number.contents);
                                                    return React.createElement(ReactBeautifulDnd.Draggable, {
                                                                draggableId: modification.external_id,
                                                                index: index,
                                                                children: (function (provided, _snapshot, _r) {
                                                                    var match = modification.status;
                                                                    var tmp;
                                                                    var exit = 0;
                                                                    switch (role.TAG | 0) {
                                                                      case /* BusinessAdmin */0 :
                                                                      case /* CityAdmin */1 :
                                                                          exit = 1;
                                                                          break;
                                                                      case /* User */2 :
                                                                          tmp = null;
                                                                          break;
                                                                      
                                                                    }
                                                                    if (exit === 1) {
                                                                      tmp = is_edited || match !== 1 ? null : React.createElement(ClonedDiv$Catalyst.make, {
                                                                              props: Draggable$Catalyst.dragHandlePropsToJs(provided.dragHandleProps),
                                                                              children: React.createElement("img", {
                                                                                    src: move_icon
                                                                                  }),
                                                                              key: modification.external_id
                                                                            });
                                                                    }
                                                                    return React.createElement(ClonedDiv$Catalyst.make, {
                                                                                props: Draggable$Catalyst.draggablePropsToJs(provided.draggableProps, provided.innerRef),
                                                                                children: React.createElement(Row$Catalyst.make, {
                                                                                      children: null,
                                                                                      className: "c-modification-handle-wrapper"
                                                                                    }, React.createElement(ModificationListItemView.make, {
                                                                                          modification: modification,
                                                                                          open_modal: open_modal,
                                                                                          action_taken: action_taken,
                                                                                          take_action_cb: take_action_cb,
                                                                                          is_prioritised: is_prioritised,
                                                                                          priority: p,
                                                                                          is_core_pricing_pending: is_core_pricing_pending
                                                                                        }), tmp),
                                                                                key: modification.external_id
                                                                              });
                                                                  }),
                                                                key: modification.external_id
                                                              });
                                                  }), priority)), e !== undefined ? Caml_option.valFromOption(e) : null)
                                  });
                      })
                  })
            });
}

var make = DragAndDropModification;

export {
  move_icon ,
  reorderLst ,
  onDragEnd ,
  make ,
  
}
/* move_icon Not a pure module */
